import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, ɵConsole } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from "file-saver";
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { bpForm2Array } from '../../_models/staticArray'
import { ChangeDateFormateService } from '../../services/change-date-formate.service';
import { scoreControllerListArray, idConfirmListArray, noisyHobbiesListArray, yesNoArray, satisfactoryArray, strengthArray, betterWorseArray, typesArray, normalityArray, urinanalysisArray, ifYesArray, ifleafletsYesArray } from '../../_models/staticArray'
declare var $: any;

@Component({
  selector: 'app-form2',
  templateUrl: './form2.component.html',
  styleUrls: ['./form2.component.scss']
})
export class Form2Component implements OnInit {

  datePlaceholder = "Choose a date"
  date1
  date2
  days = [];
  months = [];
  years = [];
  doYouSuffer: boolean = false
  selectedIdConfirmed;
  addTextPastEarProblem: boolean = false
  addTextDeafnessFamily: boolean = false
  addTextSufferedHead: boolean = false
  addTextExposureGunfire: boolean = false
  addTextHadWax: boolean = false
  addTextEarDisease: boolean = false
  addTextSufferedInjury: boolean = false
  scoreControllerList = scoreControllerListArray
  idConfirmList = idConfirmListArray
  noisyHobbiesList = noisyHobbiesListArray
  yesNo = yesNoArray
  InvestigationList;
  satisfactory = satisfactoryArray
  strength = strengthArray
  betterWorse = betterWorseArray
  types = typesArray
  normality = normalityArray
  urinanalysis = urinanalysisArray
  ifYes = ifYesArray
  ifleafletsYes = ifleafletsYesArray
  totalRightEar: Number;
  totalLeftEar: Number;
  totalInvestigation: Number;
  totalInvestigationobj = [];
  situationScore: String = "normal";
  displayTotalCount = 0
  bpArray = bpForm2Array
  isSubmit: boolean = false
  bpValidators = [Validators.pattern("^[0-9 /]+$")]

  pulseList;
  heightList;
  weightList;
  distanceVisionList;
  platesList;
  hearingList;
  showSpecifyOthers: boolean = false;
  bmi: any;
  letterToGpCheck: any;
  selectedIndex = -1
  showAdviceYes: boolean;
  showlettersIssuedYes: boolean;
  lear500: any;
  lear1000: any;
  lear2000: any;
  learTotal: any;
  rear500: any;
  rear1000: any;
  rear2000: any;
  rearTotal: number;
  examinarSign;
  checkedBy: any;
  secondTestChecked: boolean = true;
  submitDisabled: boolean = true;
  showSecondOption: boolean = false;
  secondTestDisabled: boolean = true;
  thirdTestDisabled: boolean = true;
  showSecond: boolean = false;
  // showSecond: boolean;
  showThird: boolean;
  oldForm;
  loading;
  medicalEdit;
  disableLevel: boolean;
  disableLevelConditions = [];

  selectedExaminerDay;
  selectedExaminerMonth;
  selectedExaminerYear;

  selectedCheckedByDay;
  selectedCheckedByMonth;
  selectedCheckedByYear;

  selectedDobDay;
  selectedDobMonth;
  selectedDobYear;

  showCorrected;

  @Input('candidate') candidate;
  @Input('medicalData') medicalFormData;
  @Input('personalDetails') personalDetails;
  @Output() mainForm: EventEmitter<any> = new EventEmitter();
  candidateName: any;
  isChecked2: boolean;
  isChecked: boolean;
  showExaminarSignErr: boolean;
  showCheckedSignErr: boolean;
  bmiStairsDetails: boolean;
  bmiHillDetails: boolean;
  bmiWalkDetails: boolean;

  // bmiExerciseDetails: boolean;
  bmiBreathlessDetails: boolean;
  bmiHeadacheDetails: boolean;
  bmiSnoreDetails: boolean;
  bmiTiredDetails: boolean;
  bmiRefreshedDetails: boolean;
  showleafletsIssuedYes: boolean;
  showGlassesCheck: boolean;
  showLevelError: boolean;
  isLeaflets = []
  constructor(private fb: FormBuilder, public dialog: MatDialog, public _change: ChangeDetectorRef, public dateFormate: ChangeDateFormateService) {
    let date = new Date()
    this.days = this.generateRange(1, 31)
    this.months = this.generateRange(1, 12),
      this.years = this.generateRange(1920, date.getFullYear())
    this.pulseList = this.generateRange(40, 180)
    this.heightList = this.generateRange(120, 200)
    this.weightList = this.generateRange(30, 200)
    this.distanceVisionList = this.generateRange(0, 60)
    this.platesList = this.generateRange(0, 21)
    this.hearingList = this.generateHearingRange(-10, 80)
    this.InvestigationList = this.generateRange(0, 3)
  }

  form1 = new FormGroup({
    name: new FormControl('', Validators.required),
    idConfirmed: new FormControl('', Validators.required),
    idConfirmOther: new FormControl(''),
    dob: new FormControl(''),
    currentSenCard: new FormControl(''),
    natInstNo: new FormControl(''),
    sentinalNo: new FormControl(''),
    comment: new FormControl('')
  });

  generalHealth = new FormGroup({
    bp1: new FormControl('', this.bpValidators.concat(Validators.required)),
    pulse1: new FormControl('', Validators.required),
    bp2: new FormControl('', this.bpValidators),
    pulse2: new FormControl(''),
    secondTest: new FormControl(''),
    bp3: new FormControl('', this.bpValidators),
    pulse3: new FormControl(''),
    thirdTest: new FormControl(''),
    height: new FormControl('', Validators.required),
    weight: new FormControl('', Validators.required),
    bmi: new FormControl('', Validators.required),
    mobility: new FormControl(''),
    fitness: new FormControl(''),
    pulseRhythm: new FormControl('', Validators.required),
    glucose: new FormControl('', Validators.required),
    protein: new FormControl('', Validators.required),
    bpCheckBox: new FormControl(''),
    balanceNMobility: new FormControl('', Validators.required),
    alertnessNwellbeing: new FormControl('', Validators.required),
    speech: new FormControl('', Validators.required),
    adviceGiven: new FormControl(''),
    lettersIssued: new FormControl(''),
    adviceGivenYes: new FormControl(''),
    leafletsIssued: new FormControl(''),
    leafletsIssuedYes: new FormControl(''),
    lettersIssuedYes: new FormControl(''),
    comment: new FormControl(''),
    isBmiGreater: new FormControl(''),
    bmiStairs: new FormControl(''),
    bmiStairsDetails: new FormControl(''),
    bmiHill: new FormControl(''),
    bmiHillDetails: new FormControl(''),
    bmiWalk: new FormControl(''),
    bmiWalkDetails: new FormControl(''),
    // bmiExercise : new FormControl(''),
    bmiExerciseDetails: new FormControl(''),
    bmiRefreshed: new FormControl(''),
    bmiRefreshedDetails: new FormControl(''),
    bmiBreathless: new FormControl(''),
    bmiBreathlessDetails: new FormControl(''),
    bmiTired: new FormControl(''),
    bmiTiredDetails: new FormControl(''),
    bmiHeadache: new FormControl(''),
    bmiHeadacheDetails: new FormControl(''),
    bmiSnore: new FormControl(''),
    bmiSnoreDetails: new FormControl(''),
    fatigue: new FormControl(''),
    lightHeadedness: new FormControl(''),
    dizziness: new FormControl(''),
    nausea: new FormControl(''),
    clammySkin: new FormControl(''),
    depression: new FormControl(''),
    lossOfConsciousness: new FormControl(''),
    // blurredVision: new FormControl(''),
    bmiFatigue: new FormControl(''),
    bmiLightHeadedness: new FormControl(''),
    bmiDizziness: new FormControl(''),
    bmiNausea: new FormControl(''),
    bmiClammySkin: new FormControl(''),
    bmiDepression: new FormControl(''),
    bmiLossOfConsciousness: new FormControl(''),
    bmiBlurredVision: new FormControl(''),
    bmiNormalDiet: new FormControl(''),
    bmiChangesWeight: new FormControl(''),
    bmiGastric: new FormControl(''),
    doYouSuffer: new FormControl(''),

    bpFatigue: new FormControl(''),
    bpLightHeadedness: new FormControl(''),
    bpDizziness: new FormControl(''),
    bpNausea: new FormControl(''),
    bpClammySkin: new FormControl(''),
    bpDepression: new FormControl(''),
    bpLossOfConsciousness: new FormControl(''),
    bpBlurredVision: new FormControl(''),




    // Sleep Questionnaire and Investigation

    bmiLess: new FormControl(''),
    neckCircumference: new FormControl(''),
    sittingandreading: new FormControl(''),
    watchingtv: new FormControl(''),
    inactive: new FormControl(''),
    passenger: new FormControl(''),
    circumstances: new FormControl(''),
    talkingtosomeone: new FormControl(''),
    alcohol: new FormControl(''),
    traffic: new FormControl(''),
    displayTotalCount: new FormControl('')
  })

  visionAssessment = new FormGroup({
    dvlUnaided: new FormControl('', Validators.required),
    dvrUnaided: new FormControl('', Validators.required),
    dvlCorrected: new FormControl(''),
    dvrCorrected: new FormControl(''),
    glassesWorn: new FormControl('', Validators.required),
    lensesWorn: new FormControl('', Validators.required),
    visualFields: new FormControl('', Validators.required),
    colorVision: new FormControl('', Validators.required),
    plates: new FormControl('', Validators.required),
    comment: new FormControl('')
  })



  hearingGrp = new FormGroup({
    leftEar500: new FormControl('', Validators.required),
    leftEar1000: new FormControl('', Validators.required),
    leftEar2000: new FormControl('', Validators.required),
    leftEar3000: new FormControl(''),
    leftEar4000: new FormControl(''),
    leftEar6000: new FormControl(''),
    leftEar8000: new FormControl(''),
    rightEar500: new FormControl('', Validators.required),
    rightEar1000: new FormControl('', Validators.required),
    rightEar2000: new FormControl('', Validators.required),
    rightEar3000: new FormControl(''),
    rightEar4000: new FormControl(''),
    rightEar6000: new FormControl(''),
    rightEar8000: new FormControl(''),
    total90: new FormControl(false),
    earWax: new FormControl('', Validators.required),
    // earWaxYes: new FormControl(''),
    leTotal: new FormControl('', Validators.required),
    reTotal: new FormControl('', Validators.required),
    comment: new FormControl(''),
    rightStrength: new FormControl(''),
    leftStrength: new FormControl(''),
    hearingAid: new FormControl(''),
    sufferedInjury: new FormControl(''),
    sufferedInjuryText: new FormControl(''),
    earDisease: new FormControl(''),
    earDiseaseText: new FormControl(''),
    deafnessFamily: new FormControl(''),
    deafnessFamilyText: new FormControl(''),
    sufferedHead: new FormControl(''),
    sufferedHeadText: new FormControl(''),
    sufferRinging: new FormControl(''),
    sufferFromDizziness: new FormControl(''),
    ototoxicDrugs: new FormControl(''),
    exposureGunfire: new FormControl(''),
    exposureGunfireText: new FormControl(''),
    noisyHobbies: new FormControl(''),
    noisyHobbiesConfirm: new FormControl(''),
    hearNoise: new FormControl(''),
    hadWax: new FormControl(''),
    hadWaxWhen: new FormControl(''),
    pastEarProblem: new FormControl(''),
    previousJob: new FormControl(''),
    longYear: new FormControl(''),
    longMonth: new FormControl(''),
    protectionProvided: new FormControl(''),
    type: new FormControl(''),
    motorSports: new FormControl(''),
    rideMotorcycle: new FormControl(''),
    DIY: new FormControl(''),
    discos: new FormControl(''),
    shooting: new FormControl(''),
    Other: new FormControl()
  })

  fitnessGrp = new FormGroup({
    addInfo: new FormControl(''),
    generalHealth: new FormControl(''),
    visual: new FormControl(''),
    colorVision: new FormControl(''),
    hearing: new FormControl('')
  })

  medicalAssess = new FormGroup({
    fit: new FormControl(''),
    letterToGp: new FormControl(''),
    sixMonthCerti: new FormControl(''),
    referToOHPhysician: new FormControl(''),
    referToOHPhysicianReason: new FormControl(''),
    level: new FormControl(''),
    reason: new FormControl(''),
    examinerName: new FormControl(''),
    examinerDate: new FormControl('', Validators.required),
    examinarSignature: new FormControl('', Validators.required),
    checkedBy: new FormControl(''),
    checkedByDate: new FormControl(''),
    checkedSign: new FormControl(''),
    reasonForReferral: new FormControl(''),
    comment: new FormControl(''),
    comment1: new FormControl(''),
    level1: new FormControl(false),
    level2: new FormControl(false),
    level3: new FormControl(false),
    level4: new FormControl(false),
    noLevel: new FormControl(false),
    riskAssessment: new FormControl(''),
    riskAssessmentReason: new FormControl(''),
    riskAssessmentSignature: new FormControl(''),
    isFail: new FormControl(''),
    isFailReason: new FormControl(''),
    isTempFail: new FormControl(''),
    isTempFailReason: new FormControl(''),
    glassesCheck: new FormControl(''),
    accompanied: new FormControl(''),
    validity: new FormControl('')
  })

  level1;
  level2;
  level3;
  level4;
  noLevel;
  riskAssessment;
  riskAssessmentReason;
  accompanied
  validity
  riskAssessmentSignature;
  showOccupationSignErr = false;
  selectedNoisy = []

  ngOnInit() {
    console.log('this.personalDetails', this.personalDetails)
    if (this.candidate) {
      console.log('CANDIDATE IN FORM 2', this.candidate)
      this.candidateName = this.candidate.name;
      this.form1.patchValue({
        name: this.candidate.name
      })
    }

    if (this.personalDetails) {
      this.form1.patchValue({
        name: this.candidate.name,
        idConfirmed: this.personalDetails.idConfirmed,
        idConfirmOther: this.personalDetails.idConfirmOther,
        dob: this.personalDetails.dob,
        currentSenCard: this.personalDetails.currentSenCard,
        natInstNo: this.personalDetails.natInstNo,
        sentinalNo: this.personalDetails.sentinalNo,
      })
    }
    // this.disableNewForm();

    //   if (localStorage.getItem("formone") !== null) {
    //     let itemData = JSON.parse(localStorage.getItem("formone"));
    //     console.log('itemData======>', itemData);
    //     let name = itemData.medicalQuestionnaire.firstName + ' ' + itemData.medicalQuestionnaire.surName
    //     this.form1.controls['name'].setValue(name);
    //     this.form1.controls['dob'].setValue(itemData.medicalQuestionnaire.dob);
    //     this.oldForm = itemData;
    //     this.hideFirstForm = true;
    //     this.hideSecondForm = false;
    //     this.enableNewForm();
    //   } else {
    //     this.hideFirstForm = false;
    //     this.hideSecondForm = true;
    //   }

    // }

    // enableNewForm() {
    //   this.form1.enable();
    //   this.generalHealth.enable();
    //   this.visionAssessment.enable();
    //   this.hearingGrp.enable();
    //   this.fitnessGrp.enable();
    //   this.medicalAssess.enable();
    // }

    // disableNewForm() {
    //   this.form1.disable();
    //   this.generalHealth.disable();
    //   this.visionAssessment.disable();
    //   this.hearingGrp.disable();
    //   this.fitnessGrp.disable();
    //   this.medicalAssess.disable();
  }
  showGlassWornCheck(event) {
    console.log("event.value", event.value)
    if (event.value == 'Yes') {
      this.showGlassesCheck = true
      this.medicalAssess.patchValue({
        glassesCheck: true
      })
      this.medicalAssess.updateValueAndValidity()
      console.log("this.medicalAssess ======== value", this.medicalAssess.value);

      this.showCorrected = true;
    } else {
      this.showGlassesCheck = false
      this.medicalAssess.patchValue({
        glassesCheck: false
      })
      this.medicalAssess.updateValueAndValidity()
      this.showCorrected = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    console.log('Ng on changes in form2 while edit==========', changes);

    console.log('this.generalHealth Form', this.generalHealth)

    // THis is helpfull when we update data;
    let rightEarTotal = Number(this.hearingGrp.value.rightEar500) + Number(this.hearingGrp.value.rightEar1000) + Number(this.hearingGrp.value.rightEar2000)
    this.rearTotal = rightEarTotal
    this.hearingGrp.patchValue({
      reTotal: rightEarTotal
    });
    this.hearingGrp.updateValueAndValidity();
    let leftEarTotal = Number(this.hearingGrp.value.leftEar500) + Number(this.hearingGrp.value.leftEar1000) + Number(this.hearingGrp.value.leftEar2000)
    this.learTotal = leftEarTotal
    this.hearingGrp.patchValue({
      leTotal: this.learTotal
    })
    this.hearingGrp.updateValueAndValidity();



    if (changes && changes.candidate && changes.candidate.currentValue) {
      this.form1.controls.name.setValue(changes.candidate.currentValue)
    }

    console.log("IN ON CHANGES", changes.medicalFormData);

    if (changes.medicalFormData && changes.medicalFormData.currentValue) {
      this.medicalEdit = changes.medicalFormData.currentValue;
      console.log("only medical form value display", this.medicalEdit.generalHealth);

      // console.log('idConfirmed===>', this.medicalEdit.form1.idConfirmed);
      // this.selectedIdConfirmed = this.medicalEdit.form1.idConfirmed
      if (this.medicalEdit && this.medicalEdit.generalHealth) {

        this.generalHealth.patchValue({
          isBmiGreater: this.medicalEdit.generalHealth.isBmiGreater
        })

        this.generalHealth.get("neckCircumference").patchValue(this.medicalEdit.generalHealth.neckCircumference);
        this.generalHealth.get("sittingandreading").patchValue(this.medicalEdit.generalHealth.sittingandreading);
        this.generalHealth.get("watchingtv").patchValue(this.medicalEdit.generalHealth.watchingtv);
        this.generalHealth.get("inactive").patchValue(this.medicalEdit.generalHealth.inactive);
        this.generalHealth.get("passenger").patchValue(this.medicalEdit.generalHealth.passenger);
        this.generalHealth.get("circumstances").patchValue(this.medicalEdit.generalHealth.circumstances);
        this.generalHealth.get("talkingtosomeone").patchValue(this.medicalEdit.generalHealth.talkingtosomeone);
        this.generalHealth.get("alcohol").patchValue(this.medicalEdit.generalHealth.alcohol);
        this.generalHealth.get("traffic").patchValue(this.medicalEdit.generalHealth.traffic);
        // this.displayTotalCount=this.medicalEdit.generalHealth.displayTotalCount;


        for (let i = 0; i < this.scoreControllerList.length; i++) {
          let data = this.generalHealth.get(this.scoreControllerList[i]).value
          if (data != "" && data != undefined) {
            let objdata = {
              key: this.scoreControllerList[i],
              value: data
            }
            this.totalInvestigationobj.push(objdata)

          }
        }


        if (this.totalInvestigationobj.length != 0) {
          this.displayTotalCount = 0;
          for (let i = 0; i < this.totalInvestigationobj.length; i++) {

            this.displayTotalCount = this.displayTotalCount + Number(this.totalInvestigationobj[i].value)
          }
          if (this.displayTotalCount >= 0 && this.displayTotalCount <= 10) {
            this.situationScore = "normal"
          }
          else if (this.displayTotalCount > 10 && this.displayTotalCount <= 12) {
            this.situationScore = "borderline"
          }
          else if (this.displayTotalCount > 12 && this.displayTotalCount <= 24) {
            this.situationScore = "abnormal"
          }
          this.generalHealth.patchValue({
            displayTotalCount: this.displayTotalCount
          })
        }
        console.log("this total score array data check====>", this.totalInvestigationobj)
        // this.generalHealth.patchValue({
        //   situation:this.medicalEdit.generalHealth.situation
        // })
        // console.log("check situation value=======>", this.medicalEdit.generalHealth.situation)

        this.generalHealth.patchValue({
          bmiLess: this.medicalEdit.generalHealth.bmiLess
        })

        if (this.medicalEdit.generalHealth.leafletsIssued == 'Yes') {
          this.showleafletsIssuedYes = true
        }
        if (this.medicalEdit.generalHealth && this.medicalEdit.generalHealth.bp1 && this.medicalEdit.generalHealth.bp1.length > 0) {
          // this.bpBlurred(this.medicalEdit.generalHealth.bp1, 'reading1')
          setTimeout(() => {
            this.bpBlurred(this.medicalEdit.generalHealth.bp1, 'reading1')
          }, 1000)
        }
        if (this.medicalEdit.generalHealth && this.medicalEdit.generalHealth.bp2 && this.medicalEdit.generalHealth.bp2.length > 0) {
          // this.bpBlurred(this.medicalEdit.generalHealth.bp2, 'reading2')
          // this.isChecked = true
          // let event = {
          //   checked: true
          // }
          // this.checkboxChange(event)
          setTimeout(() => {
            this.bpBlurred(this.medicalEdit.generalHealth.bp2, 'reading2')
            this.isChecked = true
            // this.showSecond = true
            let event = {
              checked: true
            }
            this.checkboxChange(event)
          }, 1000)
        }
        if (this.medicalEdit.generalHealth && this.medicalEdit.generalHealth.bp3 && this.medicalEdit.generalHealth.bp3.length > 0) {
          // this.bpBlurred(this.medicalEdit.generalHealth.bp3, 'reading3')
          // this.isChecked2 = true
          // let event = {
          //   checked: true
          // }
          // this.checkboxChange2(event)
          setTimeout(() => {
            this.bpBlurred(this.medicalEdit.generalHealth.bp3, 'reading3')
            this.isChecked2 = true
            // this.showThird = true
            let event = {
              checked: true
            }
            this.checkboxChange2(event)
          }, 1000)
        }
        this.bmi = this.medicalEdit.generalHealth.bmi
        if (this.bmi > 30) {
          console.log("this is perfect");
          if (this.medicalEdit.generalHealth.bmiStairs == "Yes") {
            this.bmiStairsDetails = true
          } else {
            this.bmiStairsDetails = false
          }
          if (this.medicalEdit.generalHealth.bmiHill == "Yes") {
            this.bmiHillDetails = true
          } else {
            this.bmiHillDetails = false
          }
          if (this.medicalEdit.generalHealth.bmiWalk == "Yes") {
            this.bmiWalkDetails = true
          } else {
            this.bmiWalkDetails = false
          }
          if (this.medicalEdit.generalHealth.bmiRefreshed == "Yes") {
            this.bmiRefreshedDetails = true
          } else {
            this.bmiRefreshedDetails = false
          }
          if (this.medicalEdit.generalHealth.bmiBreathless == "Yes") {
            this.bmiBreathlessDetails = true
          } else {
            this.bmiBreathlessDetails = false
          }

          if (this.medicalEdit.generalHealth.bmiHeadache == "Yes") {
            this.bmiHeadacheDetails = true
          } else {
            this.bmiHeadacheDetails = false
          }

          if (this.medicalEdit.generalHealth.bmiSnore == "Yes") {
            this.bmiSnoreDetails = true
          } else {
            this.bmiSnoreDetails = false
          }

          if (this.medicalEdit.generalHealth.bmiTired == "Yes") {
            this.bmiTiredDetails = true
          } else {
            this.bmiTiredDetails = false
          }
        }
      }
      if (this.medicalEdit && this.medicalEdit.recom) {
        console.log("what is the value of medical form recom", this.medicalEdit.recom);
        this.date1 = this.medicalEdit.recom.examinerDate,
          this.date2 = this.medicalEdit.recom.checkedByDate
        this.medicalAssess.patchValue({
          examinerDate: this.medicalEdit.recom.examinerDate,
          checkedByDate: this.medicalEdit.recom.checkedByDate
        })

        if (this.medicalEdit.recom.riskAssessment == "false") {
          this.medicalEdit.recom.riskAssessment = 'No'
        }
        else {
          this.medicalEdit.recom.riskAssessment = 'Yes'
        }
        this.medicalAssess.patchValue({
          level1: this.medicalEdit.recom.level1,
          level2: this.medicalEdit.recom.level2,
          level3: this.medicalEdit.recom.level3,
          level4: this.medicalEdit.recom.level4,
          noLevel: this.medicalEdit.recom.noLevel,
          riskAssessment: this.medicalEdit.recom.riskAssessment,
          riskAssessmentReason: this.medicalEdit.recom.riskAssessmentReason,
          accompanied: this.medicalEdit.recom.accompanied,
          validity: this.medicalEdit.recom.validity,
        });
        console.log("thi.medicalAssess @ edit ==> ", this.medicalAssess);
        this.level1 = this.medicalEdit.recom.level1,
          this.level2 = this.medicalEdit.recom.level2,
          this.level3 = this.medicalEdit.recom.level3,
          this.level4 = this.medicalEdit.recom.level4,
          this.noLevel = this.medicalEdit.recom.noLevel,
          this.riskAssessment = this.medicalEdit.recom.riskAssessment,
          this.riskAssessmentReason = this.medicalEdit.recom.riskAssessmentReason,
          this.accompanied = this.medicalEdit.recom.accompanied,
          this.validity = this.medicalEdit.recom.validity,
          this.medicalAssess.updateValueAndValidity();

        // if(this.medicalEdit.recom)
        this.examinarSign = this.medicalEdit.recom.examinarSignature
        this.medicalAssess.patchValue({
          examinarSignature: this.examinarSign
        })

        this.checkedBy = this.medicalEdit.recom.checkedSign
        this.medicalAssess.patchValue({
          checkedSign: this.checkedBy
        })

        this.riskAssessmentSignature = this.medicalEdit.recom.riskAssessmentSignature
        this.medicalAssess.patchValue({
          riskAssessmentSignature: this.riskAssessmentSignature
        })
      }
      if (this.medicalEdit && this.medicalEdit.generalHealth && this.medicalEdit.generalHealth.adviceGiven == 'Yes') {
        this.showAdviceYes = true
      }
      if (this.medicalEdit && this.medicalEdit.generalHealth && this.medicalEdit.generalHealth.lettersIssued == 'Yes') {
        this.showlettersIssuedYes = true
      }

      if (this.medicalEdit && this.medicalEdit.recom && this.medicalEdit.recom.glassesCheck) {
        this.showGlassesCheck = true
      }

      if (this.medicalEdit && this.medicalEdit.hearing) {
        console.log("this is for medical hearing", this.medicalEdit.hearing);
        if (this.medicalEdit.hearing.leTotal > 89 || this.medicalEdit.hearing.reTotal > 89) {
          this.hearingGrp.patchValue({
            total90: true
          })
        }
        if (this.medicalEdit.hearing.sufferedInjury == "Yes") this.addTextSufferedInjury = true

        if (this.medicalEdit.hearing.earDisease == "Yes") this.addTextEarDisease = true

        if (this.medicalEdit.hearing.deafnessFamily == "Yes") this.addTextDeafnessFamily = true

        if (this.medicalEdit.hearing.sufferedHead == "Yes") this.addTextSufferedHead = true

        if (this.medicalEdit.hearing.hadWax == "Yes") this.addTextHadWax = true

        if (this.medicalEdit.hearing.pastEarProblem == "Yes") this.addTextPastEarProblem = true
        if (this.medicalEdit.hearing.noisyHobbiesConfirm) {
          console.log("call this part or not", this.medicalEdit.hearing.noisyHobbiesConfirm);
          this.medicalEdit.hearing.noisyHobbiesConfirm.forEach((single) => {
            this.selectedNoisy.push(single)
          })
          // this.selectedNoisy = this.medicalEdit.hearing.noisyHobbiesConfirm
          console.log("if added like this", this.selectedNoisy);

          this.noisyHobbiesList.forEach(element => {
            console.log(" ELEment ", element)
            if (element == 'Motor sports') {
              console.log("element", element)
              this.hearingGrp.patchValue({
                motorSports: this.medicalEdit.hearing.motorSports
              })
              // if (this.medicalEdit.hearing.motorSports == true) {
              //   this.selectedNoisy.push(element)
              // }

            }

            if (element == 'Ride a motorcycle') {
              this.hearingGrp.patchValue({
                rideMotorcycle: this.medicalEdit.hearing.rideMotorcycle
              })
              console.log("element", element)
            }

            if (element == 'DIY') {
              this.hearingGrp.patchValue({
                DIY: this.medicalEdit.hearing.DIY
              })
              console.log("element", element)
            }

            if (element == 'Discos/loud music') {
              console.log("element", element)
              this.hearingGrp.patchValue({
                discos: this.medicalEdit.hearing.discos
              })
            }

            if (element == 'Shooting') {
              console.log("element", element)
              this.hearingGrp.patchValue({
                shooting: this.medicalEdit.hearing.shooting
              })
            }

            if (element == 'Other') {
              console.log("element", element)
              this.hearingGrp.patchValue({
                Other: this.medicalEdit.hearing.Other
              })
            }
          })
        }
      }

      if (this.medicalEdit && this.medicalEdit.vision) {
        console.log("medical form all values", this.medicalEdit.vision);

        if (this.medicalEdit.vision && this.medicalEdit.vision.glassesWorn == 'Yes') this.showCorrected = true
        this.visionAssessment.patchValue({
          dvlCorrected: this.medicalEdit.vision.dvlCorrected
        })
        this.visionAssessment.updateValueAndValidity()
      }


      // if (this.medicalEdit.form1 && this.medicalEdit.form1.dob) {
      //   let temp = this.medicalEdit.form1.dob.split('/')
      //   this.selectedDobDay = Number(temp[0])
      //   this.selectedDobMonth = Number(temp[1])
      //   this.selectedDobYear = Number(temp[2])
      // }
      // if (this.medicalEdit.recom && this.medicalEdit.recom.examinerDate) {
      //   let temp = this.medicalEdit.recom.examinerDate.split('/')
      //   this.selectedExaminerDay = Number(temp[0])
      //   this.selectedExaminerMonth = Number(temp[1])
      //   this.selectedExaminerYear = Number(temp[2])
      // }
      // if (this.medicalEdit.recom && this.medicalEdit.recom.checkedByDate) {
      //   let temp = this.medicalEdit.recom.checkedByDate.split('/')
      //   this.selectedCheckedByDay = Number(temp[0])
      //   this.selectedCheckedByMonth = Number(temp[1])
      //   this.selectedCheckedByYear = Number(temp[2])
      // }

      // this._change.detectChanges();
      // console.log('idConfirmed===>', this.selectedIdConfirmed);
    }
    if (this.medicalEdit && this.medicalEdit.vision) {
      console.log("medical form all values", this.medicalEdit.vision);

      if (this.medicalEdit.vision && this.medicalEdit.vision.glassesWorn == 'Yes') this.showCorrected = true
      this.visionAssessment.patchValue({
        dvlCorrected: this.medicalEdit.vision.dvlCorrected
      })
      this.visionAssessment.updateValueAndValidity()
    }

    if (changes.personalDetails && changes.personalDetails.currentValue) {
      this.form1.patchValue({
        name: this.personalDetails.name,
        idConfirmed: this.personalDetails.idConfirmed,
        idConfirmOther: this.personalDetails.idConfirmOther,
        dob: this.personalDetails.dob,
        currentSenCard: this.personalDetails.currentSenCard,
        natInstNo: this.personalDetails.natInstNo,
        sentinalNo: this.personalDetails.sentinalNo,
      })
    }

    // console.log('This Medical Edit Data===>', this.medicalEdit);



    // console.log('General Health===>', this.medicalEdit.generalHealth);

  }

  onValueChange() {
    // console.log('Function Calling', this.form1.value);

    // let formValue = this.form1.value;

    // if (formValue.name && formValue.idConfirmed && formValue.idConfirmed.length && formValue.dob) {
    //   console.log('Inside If');
    //   this.submitDisabled = false;
    //   this.generalHealth.enable();
    //   this.visionAssessment.enable();
    //   this.hearingGrp.enable();
    //   this.fitnessGrp.enable();
    //   this.medicalAssess.enable();
    // } else {
    //   console.log('Inside Else');
    //   this.submitDisabled = true;
    //   this.generalHealth.disable();
    //   this.visionAssessment.disable();
    //   this.hearingGrp.disable();
    //   this.fitnessGrp.disable();
    //   this.medicalAssess.disable();
    // }
  }
  fitnessChange(event, type) {
    console.log("when fitness is changed", event, type)
    if (event.value == 'Abnormal' && (type == 'vision')) {
      event.value = 'Not Satisfactory'
      this.fitnessGrp.patchValue({
        colorVision: event.value
      })

      this.medicalAssess.patchValue({
        level: 'level3'
      })

    }
    if (event.value == 'Normal' && (type == 'vision')) {
      this.fitnessGrp.patchValue({
        colorVision: ''
      })

      this.medicalAssess.patchValue({
        level: ''
      })
    }
    let obj = {
      type: type,
      value: event.value
    }

    let index = _.findIndex(this.disableLevelConditions, function (o) { return o.type == type })
    console.log("index", index);

    if (index == -1) {
      this.disableLevelConditions.push(obj)
      this.checkCondition()
    }
    else {
      this.disableLevelConditions[index] = obj
      this.checkCondition()
    }

    // if(event.value)


  }

  checkCondition() {
    console.log("checkCondition called", this.disableLevelConditions);

    // if (this.disableLevelConditions && this.disableLevelConditions.length){
    let index = _.findIndex(this.disableLevelConditions, function (o) { return o.value == 'Not Satisfactory' })
    console.log("index", index);

    if (index == -1) {
      this.disableLevel = false
    }
    else {
      this.disableLevel = true
    }
    // }
  }

  idChanged(event) {
    console.log("Id confirm changed", event)

    let temp = event.value.forEach(element => {
      if (element == 'Other') {
        console.log("element", element)
        this.showSpecifyOthers = true
      }
    });
  }

  checkboxChange(event) {
    if (event.checked == true) {
      this.secondTestDisabled = false;
      this.showSecond = true
      this.generalHealth.patchValue({
        secondTest: true
      })
      this.generalHealth.get('bp2').setValidators(this.bpValidators.concat(Validators.required))
    } else {
      this.secondTestDisabled = true;
      this.showSecond = false
      this.generalHealth.patchValue({
        secondTest: false
      })
      this.generalHealth.get('bp2').setValidators(this.bpValidators)
    }
  }

  checkboxChange2(event) {
    if (event.checked == true) {
      this.thirdTestDisabled = false;
      this.showThird = true
      this.generalHealth.patchValue({
        thirdTest: true
      })
      this.generalHealth.get('bp3').setValidators(this.bpValidators.concat(Validators.required))
    } else {
      this.thirdTestDisabled = true;
      this.showThird = false
      this.generalHealth.patchValue({
        thirdTest: false
      })
      this.generalHealth.get('bp3').setValidators(this.bpValidators)
    }
  }
  level1Change(event) {
    if (event.checked == true) {
      (<HTMLInputElement>document.getElementById("noLevel")).click();
      this.noLevel = false;
      this.medicalAssess.patchValue({
        noLevel: false
      })
      this.medicalAssess.updateValueAndValidity();
    }
    this.medicalAssess.patchValue({
      level1: event.checked
    });
    console.log(event);
    console.log(this.medicalAssess.value);
  }


  onChange(value, FormControl) {
    this.medicalAssess.controls[FormControl].setValue(value)
  }


  level2Change(event) {
    if (event.checked == true) {
      (<HTMLInputElement>document.getElementById("noLevel")).click();
      this.noLevel = false;
      this.medicalAssess.patchValue({
        noLevel: false
      })
      this.medicalAssess.updateValueAndValidity();
    }
    this.medicalAssess.patchValue({
      level2: event.checked

    })
    console.log(this.medicalAssess.value);

  }
  level3Change(event) {
    if (event.checked == true) {
      (<HTMLInputElement>document.getElementById("noLevel")).click();
      this.noLevel = false;
      this.medicalAssess.patchValue({
        noLevel: false
      })
      this.medicalAssess.updateValueAndValidity();
    }
    this.medicalAssess.patchValue({
      level3: event.checked


    })
    console.log(this.medicalAssess.value);

  }
  level4Change(event) {
    if (event.checked == true) {
      (<HTMLInputElement>document.getElementById("noLevel")).click();
      this.noLevel = false;
      this.medicalAssess.patchValue({
        noLevel: false
      })
      this.medicalAssess.updateValueAndValidity();
    }
    this.medicalAssess.patchValue({
      level4: event.checked


    })
    console.log(this.medicalAssess.value);

  }
  noLevelChange(event) {
    if (event.checked == true) {
      // (<HTMLInputElement>document.getElementById("level1")).checked = false;
      (<HTMLInputElement>document.getElementById("level1")).click();
      (<HTMLInputElement>document.getElementById("level2")).click();
      (<HTMLInputElement>document.getElementById("level3")).click();
      (<HTMLInputElement>document.getElementById("level4")).click();
      this.level1 = false;
      this.level2 = false;
      this.level3 = false;
      this.level4 = false;
      // if (checked != elm.checked) {
      //   elm.click();
      // }

      this.medicalAssess.patchValue({
        level1: false,
        level2: false,
        level3: false,
        level4: false
      });
      this.medicalAssess.updateValueAndValidity();
    }
    this.medicalAssess.patchValue({
      noLevel: event.checked
    });
    console.log(this.medicalAssess.value);
  }
  occupationRadioChange(event) {
    console.log(event)
    if (event.value == 'No') {
      this.medicalAssess.patchValue({
        riskAssessment: 'No'
      });
    }
    else {
      this.medicalAssess.patchValue({
        riskAssessment: 'Yes'
      });
    }
  }

  onCheckboxChange(e, i) {
    const checkArray: FormArray = this.generalHealth.get('bpCheckBox') as FormArray;

    if (e.target.checked) {
      this.bpArray[i].checked = true
      //   checkArray.push(new FormControl(e.target.value));
      // } else {
      //   let i: number = 0;
      //   checkArray.controls.forEach((item: FormControl) => {
      //     if (item.value == e.target.value) {
      //       checkArray.removeAt(i);
      //       return;
      //     }
      //     i++;
      //   });
    }
    else {
      this.bpArray[i].checked = null
    }
    this.generalHealth.patchValue({
      bpCheckBox: this.bpArray
    })
    console.log("const checkArray", checkArray, e)
  }
  fit(event) {
    console.log("ecent on fir check", event)
    if (event.checked) {
      this.medicalAssess.patchValue({
        fit: true
      })
    }
    else {
      this.medicalAssess.patchValue({
        fit: ''
      })
    }
  }

  letterToGp(event) {
    console.log("ecent on fir check", event.checked)
    if (event.checked) {
      this.medicalAssess.patchValue({
        letterToGp: true
      })
    }
    else {
      this.medicalAssess.patchValue({
        letterToGp: ''
      })
    }
  }
  sixMonth(event) {
    console.log("ecent on fir check", event)
    if (event.checked) {
      this.medicalAssess.patchValue({
        sixMonthCerti: true
      })
    }
    else {
      this.medicalAssess.patchValue({
        sixMonthCerti: ''
      })
    }
  }

  referToOH(event) {
    console.log("ecent on fir check", event)
    if (event.checked) {
      this.medicalAssess.patchValue({
        referToOHPhysician: true
      })
    }
    else {
      this.medicalAssess.patchValue({
        referToOHPhysician: ''
      })
    }
  }


  bpBlurred(event, reading) {
    let temp;
    console.log('event=====>', reading);

    this.bpArray.forEach(el => {
      el.checked = null
    })
    // console.log("BP", event.target.value)
    if (event && event.target) {
      temp = event.target.value.split('/')
    }
    else {
      temp = event.split('/')
    }

    console.log("temp", temp, Number(temp[0]) >= 90)
    if (temp[0] > 160 || temp[1] > 95) {
      console.log("this is first if condition");

      let event = {
        checked: true
      }
      if (reading == 'reading1') {
        this.isChecked = true
        this.checkboxChange(event)
      }
      else if (reading == 'reading2') {
        this.isChecked2 = true
        this.checkboxChange2(event)
      }
    }
    // if (temp.length == 2) {
    //   if ((Number(temp[0]) >= 90 && Number(temp[0]) <= 140) && (Number(temp[1]) >= 60 && Number(temp[1] <= 90))) {
    //     console.log("!!!!!!!!!!!!")
    //     this.bpArray[0].checked = true
    //   }
    //   else if ((Number(temp[0]) >= 140 && Number(temp[0]) <= 160) && (Number(temp[1]) >= 90 && Number(temp[1] <= 95))) {
    //     this.bpArray[1].checked = true
    //     this.bpArray[2].checked = true
    //   }
    //   else if (Number(temp[0]) > 180 && Number(temp[1]) > 100) {
    //     this.bpArray[3].checked = true
    //   }
    //   this.generalHealth.patchValue({
    //     bpCheckBox: this.bpArray
    //   })
    // }
    if (temp.length == 2) {
      console.log("this is the second if condition", temp[0]);

      if ((Number(temp[0]) >= 90 && Number(temp[0]) <= 140) && (Number(temp[1]) >= 60 && Number(temp[1] <= 90))) {
        console.log("!!!!!!!!!!!!")
        this.bpArray[1].checked = true
      }
      else if ((Number(temp[0]) >= 140 && Number(temp[0]) <= 160) && (Number(temp[1]) >= 90 && Number(temp[1] <= 95))) {
        this.bpArray[2].checked = true
        // this.bpArray[2].checked = true
      }
      else if ((Number(temp[0]) >= 160 && Number(temp[0]) <= 180) && (Number(temp[1]) >= 95 && Number(temp[1] <= 100))) {
        // console.log("%cChecking This Condition", Number(temp[0]), Number(temp[0]), Number(temp[1]), Number(temp[1]), "color: Orange");

        // this.bpArray[1].checked = true
        this.bpArray[3].checked = true
      }
      else if (Number(temp[0]) > 180 && Number(temp[1]) > 100) {
        this.bpArray[4].checked = true
      }
      else if (Number(temp[0]) < 90) {
        this.bpArray[0].checked = true
      }
      this.generalHealth.patchValue({
        bpCheckBox: this.bpArray
      })
      console.log("What is the bpArray", this.bpArray);

      console.log(Number(temp[0]))
      console.log(Number(temp[1]))

      if (Number(temp[0]) <= 90 && Number(temp[1]) <= 60) {
        this.doYouSuffer = true;
        this.generalHealth.patchValue({
          doYouSuffer: "Yes"
        })
      }
      else {
        this.doYouSuffer = false;
        console.log("hello here is the temp ====>", this.doYouSuffer)
        this.generalHealth.patchValue({
          doYouSuffer: null
        })
      }

    }
    console.log('this.generalHealth.value', this.generalHealth.value)
  }


  checkPluseRate(event) {
    // console.log("event when pluse reading enter", event);
    if (event > 100) {
      return '#FF0000'
    } else {
      return '#000000'
    }
  }
  checkBp() {
    console.log('Event Called', this.generalHealth.value);
    let healthForm = this.generalHealth.value;
    let temp = healthForm.bp1.split('/')

    // if ((Number(temp[0]) > 160 && Number(temp[1]) > 95)) {
    //   console.log('Inside range');
    //   this.showSecondOption = true;
    //   this.secondTestDisabled = false;
    // } else {
    //   this.showSecondOption = false;
    //   this.secondTestDisabled = true;
    // }
  }

  adviceGivenChanged(event) {
    console.log("adviceGivenChanged", event, this.generalHealth.value.adviceGiven)
    if (this.generalHealth.value.adviceGiven != '' && this.generalHealth.value.adviceGiven == 'Yes') {
      this.showAdviceYes = true
      this.generalHealth.patchValue({
        leafletsIssued: event.value
      })
      this.showleafletsIssuedYes = true

    }
    else {
      this.showAdviceYes = false
      this.showleafletsIssuedYes = false
      this.generalHealth.patchValue({
        adviceGivenYes: ''
      })
      this.generalHealth.patchValue({
        leafletsIssued: event.value
      })
    }
  }

  adviceMultipleSelection(event) {
    console.log("event when selected", event);

    // if (event.value && event.value.length) {
    this.generalHealth.patchValue({
      leafletsIssuedYes: event.value
    })
    // }


  }

  lettersIssuedChanged(event) {
    if (this.generalHealth.value.lettersIssued != '' && this.generalHealth.value.lettersIssued == 'Yes') {
      this.showlettersIssuedYes = true
    }
    else {
      this.showlettersIssuedYes = false
      this.generalHealth.patchValue({
        lettersIssuedYes: ''
      })
    }
  }

  leafletsIssuedChanged(event) {
    if (this.generalHealth.value.leafletsIssued != '' && this.generalHealth.value.leafletsIssued == 'Yes') {
      this.showleafletsIssuedYes = true
    }
    else {
      this.showleafletsIssuedYes = false
      this.generalHealth.patchValue({
        leafletsIssuedYes: ''
      })
    }
  }

  calcBmi(event) {
    this.generalHealth.patchValue({
      mobility: "",
      fitness: ""
    })
    let h = this.generalHealth.value.height
    let w = this.generalHealth.value.weight
    if (h != '' && w != '') {
      this.bmi = (w / ((h / 100) * (h / 100))).toFixed(3)
      console.log("BMI", this.bmi)
      this.generalHealth.patchValue({
        bmi: this.bmi
      });
    }

    if (this.bmi >= 30) {
      this.generalHealth.patchValue({
        isBmiGreater: 'Yes'
      })
      this.generalHealth.patchValue({
        bmiLess: 'No'
      })
    }
    else if (this.bmi <= 19) {
      this.generalHealth.patchValue({
        bmiLess: 'Yes'
      })
      this.generalHealth.patchValue({
        isBmiGreater: 'No'
      })
    }
    else {
      this.generalHealth.patchValue({
        isBmiGreater: 'No'
      })
    }
  }
  leftEarChange(event, id) {
    let leftEarTotal
    console.log("this.medicalEdit && this.medicalEdit.hearing ====>")
    if (this.medicalEdit && this.medicalEdit.hearing) {
      leftEarTotal = Number(this.hearingGrp.value.leftEar500) + Number(this.hearingGrp.value.leftEar1000) + Number(this.hearingGrp.value.leftEar2000)
      this.learTotal = leftEarTotal
      this.hearingGrp.patchValue({
        leTotal: this.learTotal
      })
      this.hearingGrp.updateValueAndValidity();
    }
    else {
      console.log("EVENT", event, "id", id)
      if (id == 500) {
        this.lear500 = event.value
      }
      else if (id == 1000) {
        this.lear1000 = event.value
      }
      else if (id == 2000) {
        this.lear2000 = event.value
      }

      console.log("EVENT", this.lear500, this.lear1000, this.lear2000)

      if (this.lear500 != undefined && this.lear1000 != undefined && this.lear2000 != undefined) {
        leftEarTotal = Number(this.lear500) + Number(this.lear1000) + Number(this.lear2000)
        this.learTotal = leftEarTotal
        this.hearingGrp.patchValue({
          leTotal: this.learTotal
        })
        if (this.learTotal > 89 || this.rearTotal > 89) {
          this.hearingGrp.patchValue({
            total90: true
          })
        }
        else {
          this.hearingGrp.patchValue({
            total90: false
          })
        }
      }
    }

  }
  rightEarChange(event, id) {
    let rightEarTotal
    console.log('RIGHT EAR CHANGE', this.hearingGrp.value.rightEar500, this.hearingGrp.value.rightEar1000, this.hearingGrp.value.rightEar2000)
    if (this.medicalEdit && this.medicalEdit.hearing) {
      rightEarTotal = Number(this.hearingGrp.value.rightEar500) + Number(this.hearingGrp.value.rightEar1000) + Number(this.hearingGrp.value.rightEar2000)
      this.rearTotal = rightEarTotal
      this.hearingGrp.patchValue({
        reTotal: rightEarTotal
      })
    }
    else {
      if (id == 500) {
        this.rear500 = event.value
      }
      else if (id == 1000) {
        this.rear1000 = event.value
      }
      else if (id == 2000) {
        this.rear2000 = event.value
      }

      if (this.rear500 != undefined && this.rear1000 != undefined && this.rear2000 != undefined) {
        rightEarTotal = Number(this.rear500) + Number(this.rear1000) + Number(this.rear2000)
        this.rearTotal = rightEarTotal
      }
      this.hearingGrp.patchValue({
        reTotal: rightEarTotal
      })
      if (this.rearTotal > 89 || this.learTotal > 89) {
        this.hearingGrp.patchValue({
          total90: true
        })
      }
      else {
        this.hearingGrp.patchValue({
          total90: false
        })
      }
    }

    // console.log("EVENT", event, "id", id)


    // }
  }

  generateRange(start, end) {
    return _.range(start, end + 1, 1)
  }

  generateHearingRange(start, end) {
    return _.range(start, end + 1, 5)
  }

  redirect(role) {
    // this.router.navigateByUrl('/signature')
    this.openDialog(SignaturePadComponent).subscribe(data => {
      console.log("data from signature", data)
      if (role == 'examinar') {
        this.examinarSign = data
        this.showExaminarSignErr = false
        this.medicalAssess.patchValue({
          examinarSignature: this.examinarSign
        })
      }
      else if (role == 'riskAssessmentSignature') {
        this.riskAssessmentSignature = data
        this.showOccupationSignErr = false
        this.medicalAssess.patchValue({
          riskAssessmentSignature: this.riskAssessmentSignature
        })
      }
      else {
        this.checkedBy = data
        this.showCheckedSignErr = false
        this.medicalAssess.patchValue({
          checkedSign: this.checkedBy
        })
      }
    })
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }
  private saveToFileSystem(response) {
    let byteArray = new Uint8Array(response.data);
    let blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, 'medical-consent');
    window.location.reload();
    // this.loading = false;
  }

  bmiQuestions(event, type) {
    console.log('event', event, 'type', type)
    if (event.value == 'Yes') {
      switch (type) {
        case 'bmiStairs':
          this.bmiStairsDetails = true
          break;
        case 'bmiHill':
          this.bmiHillDetails = true
          break;
        case 'bmiWalk':
          this.bmiWalkDetails = true
          break;
        // case 'bmiExercise':
        //   this.bmiExerciseDetails = true
        //   break;
        case 'bmiBreathless':
          this.bmiBreathlessDetails = true
          break;
        case 'bmiHeadache':
          this.bmiHeadacheDetails = true
          break;

        case 'bmiSnore':
          this.bmiSnoreDetails = true
          break;
        case 'bmiTired':
          this.bmiTiredDetails = true
          break;
        case 'bmiRefreshed':
          this.bmiRefreshedDetails = false
          break;

        ///////////
        // case 'bmiRefreshed':
        //   this.bmiRefreshedDetails = false
        //   break;
        // case 'bmiRefreshed':
        //   this.bmiRefreshedDetails = false
        //   break;
        // case 'bmiRefreshed':
        //   this.bmiRefreshedDetails = false
        //   break;
        // case 'bmiRefreshed':
        //   this.bmiRefreshedDetails = false
        //   break;
        // case 'bmiRefreshed':
        //   this.bmiRefreshedDetails = false
        //   break;
        // case 'bmiRefreshed':
        //   this.bmiRefreshedDetails = false
        //   break;
        default:
          break;
      }
      // if (type == 'bmiStairs'){
      //   this.bmiStairsDetails = true
      // } 
      // else if (type == 'bmiHill'){
      //   this.bmiHillDetails = true
      // }
      // else if (type == 'bmiWalk'){
      //   this.bmiWalkDetails = true
      // }
      // else if (type = 'bmiExercise'){
      //   this.bmiExerciseDetails = true
      // }
    }
    else {
      // if (type == 'bmiStairs') {
      //   this.bmiStairsDetails = false
      // }
      // else if (type == 'bmiHill') {
      //   this.bmiHillDetails = false
      // }
      // else if (type == 'bmiWalk') {
      //   this.bmiWalkDetails = false
      // }
      // else if (type = 'bmiExercise') {
      //   this.bmiExerciseDetails = false
      // }
      switch (type) {
        case 'bmiStairs':
          this.bmiStairsDetails = false
          break;
        case 'bmiHill':
          this.bmiHillDetails = false
          break;
        case 'bmiWalk':
          this.bmiWalkDetails = false
          break;
        // case 'bmiExercise':
        //   this.bmiExerciseDetails = false
        //   break;
        case 'bmiBreathless':
          this.bmiBreathlessDetails = false
          break;
        case 'bmiHeadache':
          this.bmiHeadacheDetails = false
          break;

        case 'bmiSnore':
          this.bmiSnoreDetails = false
          break;
        case 'bmiTired':
          this.bmiTiredDetails = false
          break;
        case 'bmiRefreshed':
          this.bmiRefreshedDetails = true
          break;
        default:
          break;
      }
    }
  }

  levelSelected(event) {
    console.log("level Selected event", event)
  }


  submit() {
    console.log("call this submit form or not", this.medicalAssess.value);

    this.form1.patchValue({

    })

    // if (this.selectedExaminerDay && this.selectedExaminerMonth && this.selectedExaminerYear) {
    //   this.medicalAssess.patchValue({
    //     examinerDate: this.selectedExaminerDay + '/' + this.selectedExaminerMonth + '/' + this.selectedExaminerYear,
    //     // checkedByDate: this.selectedCheckedByDay + '/' + this.selectedCheckedByMonth + '/' + this.selectedCheckedByYear,
    //   })
    // }
    // else {
    //   this.medicalAssess.controls.examinerDate.setErrors({
    //     inValid: true
    //   })
    // }

    // if (this.selectedCheckedByDay && this.selectedCheckedByMonth && this.selectedCheckedByYear) {
    //   this.medicalAssess.patchValue({
    //     // examinerDate: this.selectedExaminerDay + '/' + this.selectedExaminerMonth + '/' + this.selectedExaminerYear,
    //     checkedByDate: this.selectedCheckedByDay + '/' + this.selectedCheckedByMonth + '/' + this.selectedCheckedByYear,
    //   })
    // }
    // else {
    //   this.medicalAssess.controls.checkedByDate.setErrors({
    //     inValid: true
    //   })
    // }


    if (this.medicalAssess.valid && this.medicalAssess.valid) {
      console.log("value of galsss form", this.showGlassesCheck);
      console.log("what is the medical assess value", this.medicalAssess.value);

      if (this.showGlassesCheck == true) {
        this.medicalAssess.patchValue({
          glassesCheck: true
        })
        this.medicalAssess.updateValueAndValidity()
      } else {
        this.medicalAssess.patchValue({
          glassesCheck: false
        })
        this.medicalAssess.updateValueAndValidity()
      }

      console.log('TYPEOF ====>>>>>', this.generalHealth.get('bpCheckBox').value)
      if (!this.generalHealth.get('bpCheckBox').value) {
        console.log('IS STRING', this.generalHealth.controls['bpCheckBox'].value)
        this.generalHealth.patchValue({
          bpCheckBox: this.bpArray
        })
        this.generalHealth.get('bpCheckBox').updateValueAndValidity();
      }
      if (this.medicalAssess.value.riskAssessment == 'No') {
        this.medicalAssess.patchValue({
          riskAssessment: false
        });
      }
      else {
        this.medicalAssess.patchValue({
          riskAssessment: true
        });
      }
      let data = {
        form1: this.form1.value,
        generalHealth: this.generalHealth.value,
        vision: this.visionAssessment.value,
        hearing: this.hearingGrp.value,
        fitness: this.fitnessGrp.value,
        recom: this.medicalAssess.value,
      }
      console.log('Final Data to submit', data);
      this.mainForm.emit({ mainForm: data })
    }
    else {
      this.medicalAssess.markAllAsTouched()
      console.log("medical form history", this.medicalAssess);

      if (this.medicalAssess.controls['examinarSignature'].status == 'INVALID') {
        console.log("this.medicalAssess.controls['examinarSignature'].status", this.medicalAssess.controls['examinarSignature'].status);

        this.showExaminarSignErr = true
        // this.showCheckedSignErr = true
      }
      if (this.medicalAssess.controls['examinerDate'].status == 'INVALID') this.isSubmit = true
      else this.isSubmit = false
      // if (this.medicalAssess.controls['checkedSign'].status == 'INVALID') {
      //   console.log("this.medicalAssess.controls['checkedSign'].status == 'INVALID'", this.medicalAssess.controls['checkedSign'].status == 'INVALID');

      //   this.showCheckedSignErr = true
      // }

      // if (this.medicalAssess.controls['level'].status == 'INVALID') {
      //   this.showLevelError = true
      //   console.log("call this or not", this.medicalAssess.controls);
      //   // this.medicalAssess.controls.level.setErrors({
      //   //   inValid: true
      //   // })
      // } else {
      //   this.showLevelError = true
      // }
    }
  }


  completeAsFailReferToGP() {
    // console.log(" ****** completeAsFailReferToGP ******")
    console.log(" ****** Hey Yash ", this.generalHealth.value['pulse1'])
    console.log(" ****** Hey Yash Demo *********", this.generalHealth.value)


    if (this.generalHealth.value && (this.generalHealth.value['pulseRhythm'] == "Abnormal" || this.generalHealth.value['pulse1'] > 100 || this.generalHealth.value['pulse2'] > 100 || this.generalHealth.value['pulse3'] > 100)) {
      console.log("Yash Pulse1")
      this.bpArray[4].checked = true
      this.letterToGpCheck = true
      this.medicalAssess.patchValue({
        letterToGp: true
      })

    }
    else if ((this.generalHealth.value['glucose'] == '++' || this.generalHealth.value['glucose'] == '+++') && this.generalHealth.value['protein'] == '+++') {
      this.bpArray[4].checked = true
      this.letterToGpCheck = true
      this.medicalAssess.patchValue({
        letterToGp: true
      })
    }

    if ((this.generalHealth.value && this.generalHealth.value['pulse1']) && this.generalHealth.value['bp2'] == "" && this.generalHealth.value['bp1'] && (this.generalHealth.value['pulse1'] < 40 || this.generalHealth.value['pulse1'] > 100 && this.generalHealth.value['pulse2'] == "")) {
      console.log("Yash Pulse1==============", this.generalHealth.value)
      this.bpArray.forEach(el => {
        el.checked = null
      })
      this.bpArray[4].checked = true
      this.letterToGpCheck = true
      this.medicalAssess.patchValue({
        letterToGp: true
      })
      let event = {
        checked: true
      }
      this.isChecked = true
      this.checkboxChange(event)
    }
    else if (this.generalHealth.value && (this.generalHealth.value['pulse2'] != "") && this.generalHealth.value['bp3'] == "" && this.generalHealth.value['bp2'] && (this.generalHealth.value['pulse2'] < 40 || this.generalHealth.value['pulse2'] > 100 && this.generalHealth.value['pulse3'] == "")) {
      console.log("Yash Pulse2", this.generalHealth.value['pulse1'])
      this.bpArray.forEach(el => {
        el.checked = null
      })
      this.bpArray[4].checked = true
      this.letterToGpCheck = true
      this.medicalAssess.patchValue({
        letterToGp: true
      })
      let event = {
        checked: true
      }
      this.isChecked2 = true
      this.checkboxChange2(event)
    }
    else if (this.generalHealth.value && (this.generalHealth.value['pulse3'] != "") && (this.generalHealth.value['pulse3'] < 40 || this.generalHealth.value['pulse3'] > 100)) {
      console.log("Yash Pulse3", this.generalHealth.value['pulse1'])

      this.bpArray.forEach(el => {
        el.checked = null
      })
      this.bpArray[4].checked = true
      this.letterToGpCheck = true
      this.medicalAssess.patchValue({
        letterToGp: true
      })
    }
    else {
      console.log("Yash Pulse Else")
      if (this.generalHealth.value['pulse1'] && this.generalHealth.value['pulse2'] == "") {
        this.bpBlurred(this.generalHealth.value['bp1'], 'reading1')
        // this.isChecked = false
        let event = {
          checked: false
        }
        this.isChecked = false
        this.checkboxChange(event)
      } else if (this.generalHealth.value['pulse2'] && this.generalHealth.value['pulse3'] == "") {
        this.bpBlurred(this.generalHealth.value['bp2'], 'reading2')
        // this.isChecked2 = false
        let event = {
          checked: false
        }
        this.isChecked2 = false
        this.checkboxChange2(event)
      } else {
        this.bpBlurred(this.generalHealth.value['bp3'], 'reading3')
      }
      this.bpArray[4].checked = null
      this.letterToGpCheck = null
      this.medicalAssess.patchValue({
        letterToGp: null
      })
    }
    this._change.detectChanges()
  }

  earProblems() {
    // if(this.generalHealth.value['pulse2'])
    console.log("Ear case", this.hearingGrp.value['sufferedInjury'])

    if (this.hearingGrp.value['sufferedInjury'] && this.hearingGrp.value['sufferedInjury'] == 'Yes') {
      this.addTextSufferedInjury = true
    }
    else {
      this.addTextSufferedInjury = false
    }

    if (this.hearingGrp.value['earDisease'] && this.hearingGrp.value['earDisease'] == 'Yes') {
      this.addTextEarDisease = true
    }
    else {
      this.addTextEarDisease = false
    }


    if (this.hearingGrp.value['deafnessFamily'] && this.hearingGrp.value['deafnessFamily'] == 'Yes') {
      this.addTextDeafnessFamily = true
    }
    else {
      this.addTextDeafnessFamily = false
    }

    if (this.hearingGrp.value['sufferedHead'] && this.hearingGrp.value['sufferedHead'] == 'Yes') {
      this.addTextSufferedHead = true
    }
    else {
      this.addTextSufferedHead = false
    }


    if (this.hearingGrp.value['exposureGunfire'] && this.hearingGrp.value['exposureGunfire'] == 'Yes') {
      this.addTextExposureGunfire = true
    }
    else {
      this.addTextExposureGunfire = false
    }


    if (this.hearingGrp.value['hadWax'] && this.hearingGrp.value['hadWax'] == 'Yes') {
      this.addTextHadWax = true
    }
    else {
      this.addTextHadWax = false
    }

    if (this.hearingGrp.value['pastEarProblem'] && this.hearingGrp.value['pastEarProblem'] == 'Yes') {
      this.addTextPastEarProblem = true
    }
    else {
      this.addTextPastEarProblem = false
    }

  }


  noisyHobbiesChanged(event) {
    console.log("Id confirm changed", event)

    this.hearingGrp.patchValue({
      motorSports: false
    })

    this.hearingGrp.patchValue({
      rideMotorcycle: false
    })

    this.hearingGrp.patchValue({
      DIY: false
    })

    this.hearingGrp.patchValue({
      discos: false
    })

    this.hearingGrp.patchValue({
      shooting: false
    })

    this.hearingGrp.patchValue({
      Other: false
    })


    this.hearingGrp.value['noisyHobbiesConfirm'].forEach(element => {
      console.log(" ELEment ", element)
      if (element == 'Motor sports') {
        console.log("element", element)
        this.hearingGrp.patchValue({
          motorSports: true
        })

      }

      if (element == 'Ride a motorcycle') {
        this.hearingGrp.patchValue({
          rideMotorcycle: true
        })
        console.log("element", element)
      }

      if (element == 'DIY') {
        this.hearingGrp.patchValue({
          DIY: true
        })
        console.log("element", element)
      }

      if (element == 'Discos/loud music') {
        console.log("element", element)
        this.hearingGrp.patchValue({
          discos: true
        })
      }

      if (element == 'Shooting') {
        console.log("element", element)
        this.hearingGrp.patchValue({
          shooting: true
        })
      }

      if (element == 'Other') {
        console.log("element", element)
        this.hearingGrp.patchValue({
          Other: true
        })
      }
    })
  }

  changeQuestioner(value, quetion) {
    console.log("value of chamges in this file====>", value)
    let itemobj = {
      key: quetion,
      value: value
    }

    let index = this.totalInvestigationobj.findIndex((x) => x.key == quetion)



    console.log("what is the index value", index);
    if (index == -1) {
      this.totalInvestigationobj.push(itemobj)
    } else {
      this.totalInvestigationobj[index].value = value
    }

    console.log("this is the final out put of array", this.totalInvestigationobj);


    if (this.totalInvestigationobj.length != 0) {
      this.displayTotalCount = 0;
      for (let i = 0; i < this.totalInvestigationobj.length; i++) {

        this.displayTotalCount = this.displayTotalCount + Number(this.totalInvestigationobj[i].value)
      }
      if (this.displayTotalCount >= 0 && this.displayTotalCount <= 10) {
        this.situationScore = "normal"
        console.log('normal')
      }
      else if (this.displayTotalCount > 10 && this.displayTotalCount <= 12) {
        this.situationScore = "borderline"
        console.log('borderline')
      }
      else if (this.displayTotalCount > 12 && this.displayTotalCount <= 24) {
        this.situationScore = "abnormal"
        console.log("abnormal")
      }
      console.log("this is final count to display", this.displayTotalCount);
      this.generalHealth.patchValue({
        displayTotalCount: this.displayTotalCount
      })
    }


  }



  // examinerDateChange(event) {
  //   let selectedDate = event.value
  //   // let finalDate this.dateFormate.convertDate(selectedDate)

  //   // let finalDate = moment(selectedDate).format("YYYY-MM-DD")
  //   // console.log("what is the final date of selected", finalDate);
  //   this.medicalAssess.patchValue({
  //     examinerDate: this.dateFormate.convertDate(selectedDate)
  //   })
  //   this.medicalAssess.updateValueAndValidity()
  // }
  checkedByDateChange(event) {

    let selectedDate = event.value
    // let finalDate this.dateFormate.convertDate(selectedDate)

    // let finalDate = moment(selectedDate).format("YYYY-MM-DD")
    // console.log("what is the final date of selected", finalDate);
    this.medicalAssess.patchValue({
      checkedByDate: this.dateFormate.convertDate(selectedDate)
    })
    this.medicalAssess.updateValueAndValidity()
  }

}